// assets
import { IconDashboard } from '@tabler/icons';

// constant
const icons = { IconDashboard };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const stats = {
    id: 'stats',
    title: 'Estadísticas',
    type: 'group',
    children: [
        {
            id: 'stats',
            title: 'Estadísticas',
            type: 'item',
            url: '/stats',
            icon: icons.IconDashboard,
            breadcrumbs: false
        }
    ]
};

export default stats;
